export default __webpack_public_path__ + "static/media/Lamborghini.9b7eeefb.png";